export type WalletMobileAction = "send_verification" | "redeem_plan" | "request_payout";

interface WalletMobileActionsInput {
  canRedeemForPlan: boolean;
  canRequestPayout: boolean;
  /** The PIX verification form is open and has a document selected. */
  verificationReadyToSend: boolean;
}

/**
 * Buttons of the fixed bottom bar on mobile, top to bottom.
 *
 * The PIX verification form is the last block of the page, so this bar sits
 * on top of its send button. Once a document is selected, sending it is the
 * only thing the bar offers; a payout cannot be requested before the
 * verification is approved anyway.
 */
export function resolveWalletMobileActions({
  canRedeemForPlan,
  canRequestPayout,
  verificationReadyToSend,
}: WalletMobileActionsInput): WalletMobileAction[] {
  if (verificationReadyToSend) return ["send_verification"];

  const actions: WalletMobileAction[] = [];
  if (canRedeemForPlan) actions.push("redeem_plan");
  if (canRequestPayout) actions.push("request_payout");
  return actions;
}
